export const social = ['facebook', 'instagram'];
